module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_14.f152b1bc.png";